import React, { useState } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import { useForm } from "react-hook-form";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import AuthShell from "../AuthShell";

const ResetPassword = () => {
  const baseUrl = "https://fedex-delivery-five.vercel.app/api/";
  const { handleSubmit, register } = useForm({ mode: "onBlur" });
  const [loading, setLoading] = useState(false);

  const handleResetPassword = (formData) => {
    setLoading(true);
    axios.post(baseUrl + "auth/forget", { email: formData.email })
      .then(() => {
        toast.success("Check your email for a password reset link");
        setLoading(false);
      })
      .catch((error) => {
        setLoading(false);
        if (error?.response?.data === "Wrong credentials") toast.error("We could not find an account with that email");
        else toast.error("We could not send a reset link. Please try again.");
      });
  };

  return (
    <AuthShell
      variant="recovery"
      title="Reset your password"
      description="Enter the email address for your account. We’ll send you a link to continue."
      footer={<p>Remembered your password? <Link to="/auth/login">Sign in</Link></p>}
    >
      <form className="auth-form" onSubmit={handleSubmit(handleResetPassword)} noValidate>
        <label className="auth-field" htmlFor="recovery-email">Email address
          <input id="recovery-email" type="email" autoComplete="email" placeholder="you@example.com" {...register("email", { required: "Email is required" })} />
        </label>
        <button className="auth-submit" type="submit" disabled={loading}>{loading ? "Sending reset link…" : "Send reset link"}<span aria-hidden="true">→</span></button>
      </form>
      <ToastContainer position="top-right" newestOnTop />
    </AuthShell>
  );
};

export default ResetPassword;
